module.exports = __webpack_public_path__ + "static/media/YourEmpty.88df0f24.svg";